<template>
  <body data-v-7ba5bd90="" class="akl">
    <div id="skipToContent"><a href="#contents">콘텐츠 바로가기 </a></div>
    <div class="renew-compliance">
    <div class="general-header"></div>

    <div class="container amway-theme" id="contents">
        <h1 class="title-h2">장바구니 스마트오더 이용시 동의 사항</h1>
        <div class="compliance-area privacy">

            <div class="termsWrapper">
                <div class="col-search-tab link-to">
                    <ul>
                        <li class="active"><a @click="scrollToElement('titNo01')" data-toggle="tab">장바구니 스마트오더 이용시 동의 사항</a></li>
                        <li><a @click="scrollToElement('titNo02')" data-toggle="tab">개인정보 수집 및 이용에 대한 동의</a></li>
                        <li><a @click="scrollToElement('titNo03')" data-toggle="tab">TOSS 개인정보 수집 이용 동의</a></li>
                        <li><a @click="scrollToElement('titNo04')" data-toggle="tab">TOSS 전자금융거래 기본 약관</a></li>
                        <li><a @click="scrollToElement('titNo05')" data-toggle="tab">TOSS 개인정보 제3자 제공 동의</a></li>
                    </ul>
                </div>
                <ul>
                    <!-- S : 장바구니 스마트오더 이용시 동의 사항 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo01" ref="titNo01">장바구니 스마트오더 이용시 동의 사항</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더는 생활에 필요한 제품을 장바구니에 담아 신청하면 매달 원하는 날에 집으로 배송해 드리는 한국암웨이의 정기 배송 프로그램입니다. 매달 주문 제품 구성과 배송일을 자유롭게 지정할 수 있으며, 유지기간과 결제 금액에 따라 풍성한 혜택을 제공합니다.</p>
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더 프로그램을 이용할 경우 최대 24개월 간 장바구니 스마트 오더를 신청할 수 있습니다.</p>
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더의 최소 주문금액은 10만원이며, 자동결제일은 매달 2일~27일 (신용카드: 2일~27일, 자동이체: 2일~25일) 중 지정할 수 있습니다</p>
                                    <p class="titHtext">•&nbsp;&nbsp;마이쇼핑정보 > 장바구니 스마트 오더 내역를 통해 매달 주문 제품과 배송정보, 결제 정보를 변경할 수 있습니다.</p>
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더 고객은 2회차~24회차 결제까지 A Cliks로 전달된 제품 결제 시 현금처럼 사용할 수 있는 A Cliks Money를 적립할 수 있으며, 유지기간과 금액에 따라 5,000~15,000 A Cliks Money를 제공합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">장바구니 스마트 오더 A Cliks Money혜택</p>
                                    <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                        <caption>장바구니 스마트 오더 A Cliks Money혜택 표 : 주문금액, 2~5회차, 6~11회차, 12~24회차</caption>
                                        <colgroup>
                                            <col width="25%">
                                            <col width="25%">
                                            <col width="25%">
                                            <col width="25%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">주문금액</th>
                                                <th scope="col">2~5회차</th>
                                                <th scope="col">6~11회차</th>
                                                <th scope="col">12~24회차</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>10만원 이상</td>
                                                <td>5,000원</td>
                                                <td>10,000원</td>
                                                <td>15,000원</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더 진행 중 회원 탈퇴 시 적립된 A Cliks Money는 삭제되며, Registered Customer (준)회원이 스마트 오더 진행 중 중도에 Registered Customer (준)회원을 탈퇴하고 ABO로 가입하는 경우에도 적립된 A Cliks Money는 계정에서 삭제됩니다. 단, 장바구니 스마트 오더 구매 기간은 새롭게 적립되는 A Cliks Money의 산정 기준이 됩니다.</p>
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더를 통해 Registered Customer (준)회원이 제품을 주문한 경우, 장바구니 스마트 오더 구매링크를 공유한 ABO에 대하여 PV가 적립됩니다.</p>
                                    <p class="titHtext">•&nbsp;&nbsp;장바구니 스마트 오더 프로그램의 혜택 및 내용, A Cliks Money의 사용 조건 등 본 프로그램과 관련된 구체적인 운영기준은 회사의 정책에 따라 추가되거나 변경될 수 있습니다. 상기 사항이 변경될 경우 회사가 인터넷 홈페이지, 이메일 등을 통해 공지하며, 불리한 조건 변경일 경우, 변경일 1개월 전에 이메일을 통하여 개별적으로 공지합니다.</p>
                                    <p class="titHtext">주문하실 상품의 상품명, 가격, 배송정보를 확인하였으며, 이에 동의(전자상거래법 제8조 제2항)</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 장바구니 스마트오더 이용시 동의 사항 -->

                    <!-- S : 개인정보 수집 및 이용에 대한 동의 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo02" ref="titNo02">개인정보 수집 및 이용에 대한 동의</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">개인정보 이용 목적과 항목</p>
                                    <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                        <caption>개인정보 이용 목적과 항목 표 : 항목, 목적</caption>
                                        <colgroup>
                                            <col width="25%">
                                            <col width="*">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">항목</th>
                                                <th scope="col">목적</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>대금 결제 서비스</td>
                                                <td class="left">ABO 번호 또는 회원 ID, 이름, 신용카드 정보, 계좌정보, A 포인트 정보, 생년월일(결제 방식에 따른 정보 수집)</td>
                                            </tr>
                                            <tr>
                                                <td>상품 배송</td>
                                                <td class="left">이름, 주소, 휴대폰번호, 전화번호(선택)</td>
                                            </tr>
                                            <tr>
                                                <td>현금 영수증 발급 (현금 영수증 발급 신청 시)</td>
                                                <td class="left">휴대폰 번호</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">(공통) 이용·보유기간</p>                                    
                                    <p class="titHtext">계약 또는 청약철회 등에 관한 기록 5년</p>
                                    <p class="titHtext">대금결제 및 재화 등의 공급에 관한 기록 5년</p>
                                    <p class="mgtS txt-italic" style="margin:0 !important;font-style:normal;">개인정보 수집 및 이용에 대한 동의를 거부하실 수 있으나, 거부 시 상품의 구매, 대금 결제, 배송 및 픽업이 제한됩니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">개인정보의 국외 이전에 대한 동의</p>
                                    <table class="tbl-type1 line-st">
                                        <caption>개인정보의 국외 이전에 대한 동의 표 : 이전목적, 이전국가 및 이전받는 자, 이전항목, 이전시점, 이전방법, 보유기간</caption>
                                        <colgroup>
                                            <col width="25%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th scope="row">이전목적</th>
                                                <td class="left">시스템 운영/유지보수, 설문조사 및 글로벌 비즈니스 분석, 회원정보 관리</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">이전국가 및 이전받는 자</th>
                                                <td class="left">
                                                    미국, 말레이시아, 인도, 호주, 중국 Alticor, Christian Grill (DPO), alticor_privacy@alticor.com
                                                    미국<br>Amazon Web Service, Stephen Schmit (CSO/CISO), +1-206-266-1000
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">이전항목</th>
                                                <td class="left">
                                                    - 대금 결제 서비스관련 정보 : ABO 번호 또는 회원 ID, 이름, 신용카드 정보, 계좌정보, A 포인트 정보, 생년월일 (결제 방식에 따른 정보 수집)<br>
                                                    - 상품 배송관련 정보 : 이름, 주소, 휴대폰번호, 전화번호(선택)<br>
                                                    - 현금영수증 발행 관련 정보: 휴대폰 번호
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">이전시점</th>
                                                <td class="left">주문/결제 시</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">이전방법</th>
                                                <td class="left">온라인 전송</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">보유기간</th>
                                                <td class="left">
                                                    - 계약 또는 청약철회 등에 관한 기록 5년<br>
                                                    - 대금결제 및 재화 등의 공급에 관한 기록 5년
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p class="mgtS txt-italic" style="margin-left:0;font-style:normal;">서비스 제공 시스템이 국외에 위치하므로, 동의를 거부하실 경우 상품의 구매, 대금 결제, 배송 및 픽업이 제한됩니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : 개인정보 수집 및 이용에 대한 동의 -->

                    <!-- S : TOSS 개인정보 수집 이용 동의 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo03" ref="titNo03">TOSS 개인정보 수집 이용 동의</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext">토스페이먼츠(이하 회사라 함)는 "신용정보의 이용 및 보호에 관한 법률", "전자금융거래법", "전자상거래 등에서의 소비자보호에 관한 법률", "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 및 "개인정보 보호법" 등 관련 법령을 준수하여, 이용자 권익 보호에 최선을 다하고 있습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1. 개인정보 수집·이용 목적</p>
                                    
                                    <ol>
                                        <li>
                                            •&nbsp;&nbsp;가. 전자금융거래 서비스 제공: 전자결제지급대행, 자체 간편결제 및 오픈뱅킹 등
                                            <ol>
                                                <li>o&nbsp;&nbsp;결제수단(신용카드 등)을 이용한 전자결제 서비스 제공</li>
                                                <li>o&nbsp;&nbsp;전자결제 결과 조회 및 통보</li>
                                                <li>o&nbsp;&nbsp;세금계산서 및 현금영수증 발행</li>
                                                <li>o&nbsp;&nbsp;결제한 거래의 취소 또는 환불, 상품 배송 등 전자상거래 관련 서비스 제공</li>
                                            </ol>
                                        </li>
                                        <li>
                                            •&nbsp;&nbsp;나. 서비스 이용자 관리 및 민원대응
                                            <ol>
                                                <li>o&nbsp;&nbsp;이용자 본인확인, 개인식별, 공지사항의 전달, 고객 불만 및 민원처리 등</li>
                                                <li>o&nbsp;&nbsp;금융사고 조사, 분쟁해결, 민원처리, 법령상 의무이행</li>
                                                <li>o&nbsp;&nbsp;새로운 정보와 고지사항의 안내</li>
                                            </ol>
                                        </li>
                                    </ol>

                                    <p class="mgtS txt-italic" style="margin-left:0;font-style:normal;">회사는 개인정보를 위의 목적으로 처리하며, 동의받은 목적 이외의 용도로 처리하지 않습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">2. 수집·이용하는 개인정보 항목</p>
                                    
                                    <ol>
                                        <li>
                                            •&nbsp;&nbsp;가. 전자결제 시 수집되는 항목
                                            <ol>
                                                <li>o&nbsp;&nbsp;구매자명 또는 구매자ID, 결제금액</li>
                                            </ol>
                                        </li>
                                        <li>
                                            •&nbsp;&nbsp;나. 결제수단별 수집되는 항목
                                            <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                                <caption>결제수단별 수집되는 항목 표 : 결제수단, 개인정보 항목</caption>
                                                <colgroup>
                                                    <col width="25%">
                                                    <col width="*">
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">항목</th>
                                                        <th scope="col">목적</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>신용카드</th>
                                                        <td class="left">카드번호, 카드 유효기간, 카드 비밀번호, 카드 CVC, 생년월일 등 (수기결제 시 수집항목을 구분하여 진행함)</td>
                                                    </tr>
                                                    <tr>
                                                        <th>가상계좌</th>
                                                        <td class="left">은행, 가상계좌번호, 입금자명</td>
                                                    </tr>
                                                    <tr>
                                                        <th>계좌이체</th>
                                                        <td class="left">은행, 출금계좌번호, 비밀번호, 주민등록번호(또는 사업자등록번호), 예금주</td>
                                                    </tr>
                                                    <tr>
                                                        <th>휴대폰</th>
                                                        <td class="left">통신사, 휴대폰번호, 주민등록번호 앞 7자리(생년월일, 성별)</td>
                                                    </tr>
                                                    <tr>
                                                        <th>상품권</th>
                                                        <td class="left">상품권 발행사 아이디, 비밀번호’ 또는 상품권 번호</td>
                                                    </tr>
                                                    <tr>
                                                        <th>현금영수증 발행</th>
                                                        <td class="left">
                                                            ‘주민등록번호, 휴대폰번호, 현금영수증번호, 기타 카드번호’ 중 현금영수증 발급정보<br>
                                                            [참고] 가상계좌, 계좌이체 시 현금영수증 발행 가능
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>
                                        <li>
                                            •&nbsp;&nbsp;다. 전자결제 내역 발신을 위한 정보
                                            <ol>
                                                <li>o&nbsp;&nbsp;휴대폰번호, 이메일</li>
                                            </ol>
                                        </li>
                                        <li>
                                            •&nbsp;&nbsp;라. 자체 간편결제 이용자 정보
                                            <ol>
                                                <li>o&nbsp;&nbsp;CI, 휴대폰번호, 통신사, 생년월일, 성별, 이름</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">3. 개인정보의 보유 및 이용기간</p>
                                    <p class="titHtext">원칙적으로 개인정보의 수집·이용 목적이 달성되면 지체 없이 파기합니다. 단, 관련 법령의 규정 또는 회사 내부 방침에 의하여 보존할 필요가 있는 경우 아래에서 정한 기간 동안 개인정보를 보유합니다.</p>

                                    <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                        <caption>개인정보의 보유 및 이용기간 표 : 구분, 보존 근거, 보존기간</caption>
                                        <colgroup>
                                            <col width="40%">
                                            <col width="40%">
                                            <col width="20%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">보존 근거</th>
                                                <th scope="col">보존기간</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>부정 이용 방지를 위한 결제 이용에 관한 기록</td>
                                                <td>부정 이용 방지 및 탐지</td>
                                                <td>5년</td>
                                            </tr>
                                            <tr>
                                                <td>휴대폰 본인확인 서비스 이용에 관한 기록</td>
                                                <td>정보통신 이용촉진 및 정보보호 등에 관한 법률</td>
                                                <td>6개월</td>
                                            </tr>
                                            <tr>
                                                <td>계약 또는 청약철회 등에 관한 기록</td>
                                                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                                                <td>5년</td>
                                            </tr>
                                            <tr>
                                                <td>1만원 이상 대금결제 및 재화 등의 공급에 관한 기록</td>
                                                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                                                <td>5년</td>
                                            </tr>
                                            <tr>
                                                <td>1만원 이상 대금결제 및 재화 등의 공급에 관한 기록</td>
                                                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                                                <td>5년</td>
                                            </tr>
                                            <tr>
                                                <td>1만원 미만 대금결제 및 재화 등의 공급에 관한 기록</td>
                                                <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                                                <td>1년</td>
                                            </tr>
                                            <tr>
                                                <td>웹사이트 방문 또는 자체 간편결제 접속에 관한 기록</td>
                                                <td>통신비밀보호법에 관한 법률</td>
                                                <td>3개월</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>

                            <li>
                                <div class="pdBox">
                                    <p class="titH2">4. 이용자는 회사의 개인정보 수집·이용 동의를 거부할 권리가 있습니다.</p>
                                    <p class="titHtext">다만, 개인정보의 수집·이용 동의를 거부할 경우 전자결제 서비스의 이용이 제한될 수 있음을 알려드립니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : TOSS 개인정보 수집 이용 동의 -->

                    <!-- S : TOSS 전자금융거래 기본 약관 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo04" ref="titNo04">TOSS 전자금융거래 기본 약관</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제1조 (목적)</p>
                                    <p class="titHtext">이 약관은 전자지급결제대행서비스 및 결제대금예치서비스를 제공하는 토스페이먼츠 주식회사(이하 '회사'라 합니다)와 이용자 사이의 전자금융거래에 관한 기본적인 사항을 정함으로써 전자금융거래의 안정성과 신뢰성을 확보함에 그 목적이 있습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제2조 (용어의 정의)</p>
                                    <p class="titHtext">이 약관에서 정하는 용어의 정의는 다음과 같습니다.</p>
                                    <ol>
                                        <li>① 전자금융거래'라 함은 회사가 전자적 장치를 통하여 전자지급결제대행서비스 및 결제대금예치서비스(이하 '전자금융거래 서비스'라고 합니다)를 제공하고, 이용자가 회사의 구성원과 직접 대면하거나 의사소통을 하지 아니하고 전산화된 방식으로 이를 이용하는 거래를 말합니다.</li>
                                        <li>② '전자지급결제대행 서비스'라 함은 전자적 방법으로 재화의 구입 또는 용역의 이용에 있어서 지급결제정보를 송신하거나 수신하는 것 또는 그 대가의 정산을 대행하거나 매개하는 서비스를 말합니다.</li>
                                        <li>③ ‘결제대금예치서비스'라 함은 이용자가 재화의 구입 또는 용역의 이용에 있어서 그 대가(이하 '결제대금'이라 한다)의 전부 또는 일부를 재화 또는 용역(이하 '재화 등'이라 합니다)을 공급받기 전에 미리 지급하는 경우, 회사가 이용자의 물품수령 또는 서비스 이용 확인 시점까지 결제대금을 예치하는 서비스를 말합니다.</li>
                                        <li>④ '이용자'라 함은 이 약관에 동의하고 회사가 제공하는 전자지급결제대행 서비스를 이용하는 자를 말합니다.</li>
                                        <li>⑤ '접근매체'라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적 정보(신용카드번호를 포함한다), '전자서명법'상의 인증서, 금융기관 또는 전자금융업자에 등록된 이용자번호, 이용자의 생체정보, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등 전자금융거래법 제2조 제10호에서 정하고 있는 것을 말합니다.</li>
                                        <li>⑥ '거래지시'라 함은 이용자가 전자금융거래계약에 따라 금융기관 또는 전자금융업자에게 전자금융거래의 처리를 지시하는 것을 말합니다.</li>
                                        <li>⑦ '오류'라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말합니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제3조 (약관의 명시 및 변경)</p>
                                    <ol>
                                        <li>① 회사는 이용자가 전자지급결제대행 서비스를 이용하기 전에 이 약관을 게시하고 이용자가 이 약관의 중요한 내용을 확인할 수 있도록 합니다.</li>
                                        <li>② 회사는 이용자의 요청이 있는 경우 서면제공 방식 또는 전자문서의 전송방식에 의하여 본 약관의 사본을 이용자에게 교부합니다.</li>
                                        <li>③ 회사가 약관을 변경하는 때에는 그 시행일 1월 전에 변경되는 약관을 지급결제정보 입력화면 및 회사의 홈페이지에 게시함으로써 이용자에게 공지합니다.</li>
                                        <li>④ 이용자는 제3항의 규정에 따른 약관의 변경내용이 게시되거나 통지된 후부터 변경되는 약관의 시행일 전의 영업일까지 전자금융거래의 계약을 해지할 수 있습니다. 전단의 기간 안에 이용자가 약관의 변경내용에 대하여 이의를 제기하지 아니하는 경우에는 약관의 변경을 승인한 것으로 봅니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제4조 (전자지급결제대행서비스의 종류)</p>
                                    <p class="titHtext">회사가 제공하는 전자지급결제대행서비스는 지급결제수단에 따라 다음과 같이 구별됩니다.</p>
                                    <ol>
                                        <li>① 신용카드결제대행서비스: 이용자가 결제대금의 지급을 위하여 제공한 지급결제수단이 신용카드인 경우로서, 회사가 전자결제시스템을 통한 신용카드 지불정보의 송,수신 및 결제대금의 정산을 대행하거나 매개하는 서비스를 말합니다.</li>
                                        <li>② 계좌이체대행서비스: 이용자가 결제대금을 회사의 전자결제시스템을 통하여 금융기관에 등록한 자신의 계좌에서 출금하여 원하는 계좌로 이체할 수 있는 실시간 송금 서비스를 말합니다.</li>
                                        <li>③ 가상계좌서비스: 이용자가 결제대금을 현금으로 결제하고자 경우 회사의 전자결제시스템을 통하여 자동으로 이용자만의 고유한 일회용 계좌의 발급을 통하여 결제대금의 지급이 이루어지는 서비스를 말합니다.</li>
                                        <li>④ 기타: 회사가 제공하는 서비스로서 지급결제수단의 종류에 따라 '휴대폰 결제대행서비스', 'KT전화(ARS,폰빌)결제대행서비스', '상품권결제대행서비스'등이 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제5조 (결제대금예치서비스의 내용)</p>
                                    <ol>
                                        <li>① 이용자(이용자의 동의가 있는 경우에는 재화 등을 공급받을 자를 포함합니다. 이하 본조에서 같습니다)는 재화 등을 공급받은 사실을 재화 등을 공급받은 날부터 3영업일 이내에 회사에 통보하여야 합니다.</li>
                                        <li>② 회사는 이용자로부터 재화 등을 공급받은 사실을 통보 받은 후 회사와 통신판매업자간 사이에서 정한 기일 내에 통신판매업자에게 결제대금을 지급합니다.</li>
                                        <li>③ 회사는 이용자가 재화 등을 공급받은 날부터 3영업일이 지나도록 정당한 사유의 제시 없이 그 공급받은 사실을 회사에 통보하지 아니하는 경우에는 이용자의 동의 없이 통신판매업자에게 결제대금을 지급할 수 있습니다.</li>
                                        <li>④ 회사는 통신판매업자에게 결제대금을 지급하기 전에 이용자에게 결제대금을 환급받을 사유가 발생한 경우에는 그 결제대금을 소비자에게 환급합니다.</li>
                                        <li>⑤ 회사는 이용자와의 결제대금예치서비스 이용과 관련된 구체적인 권리,의무를 정하기 위하여 본 약관과는 별도로 결제대금예치서비스이용약관을 제정할 수 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제6조 (접근매체의 선정, 관리 등)</p>
                                    <ol>
                                        <li>① 회사는 전자지급결제대행 서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인할 수 있습니다.</li>
                                        <li>② 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.</li>
                                        <li>③ 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.</li>
                                        <li>④ 회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제7조 (회사의 책임)</p>
                                    <ol>
                                        <li>① 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 있습니다. 다만, 이용자가 접근매체를 제3자에게 대여하거나 그 사용을 위임한 경우 또는 양도나 담보의 목적으로 제공한 경우, 회사가 보안강화를 위하여 전자금융거래 시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 사고가 발생한 경우, 이용자가 제6조 제2항에 위반하거나 제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 알 수 있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.</li>
                                        <li>② 회사는 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 본조 제1항 단서에 해당하거나 법인('중소기업기본법' 제2조 제2항에 의한 소기업을 제외한다)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.</li>
                                        <li>③ 회사는 전자금융거래를 위한 전자적 장치 또는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 제2조제1항제1호에 따른 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제8조 (거래내용의 확인)</p>
                                    <ol>
                                        <li>① 회사는 이용자와 미리 약정한 전자적 방법을 통하여 이용자의 거래내용(이용자의 '오류정정 요구사실 및 처리결과에 관한 사항'을 포함합니다)을 확인할 수 있도록 하며, 이용자의 요청이 있는 경우에는 요청을 받은 날로부터 2주 이내에 전자적양식, 모사전송, 서면 등의 방법으로 거래내용에 관한 서면을 교부합니다. 전자적 장치의 운영장애, 그 밖의 사유로 거래내용을 확인하게 할 수 없는 때에는 인터넷 등을 이용하여 즉시 그 사유를 알리고, 그 사유가 종료된 때부터 이용자가 거래내용을 확인할 수 있도록 하여야 합니다.</li>
                                        <li>② 회사가 이용자에게 제공하는 거래내용 중 거래계좌의 명칭 또는 번호, 거래의 종류 및 금액, 거래상대방을 나타내는 정보, 거래일자, 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보와 해당 전자금융거래와 관련한 전자적 장치의 접속기록은 5년간, 건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록, 전자지급수단 이용시 거래승인에 관한 기록, 이용자의 오류정정 요구사실 및 처리결과에 관한 사항은 1년간의 기간을 대상으로 하되, 회사가 가맹점에 대한 전자지급결제대행 서비스 제공의 대가로 수취한 수수료에 관한 사항은 제공하는 거래내용에서 제외됩니다.</li>
                                        <li>
                                            ③ 이용자가 본조 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.
                                            <ol>
                                                <li>o&nbsp;&nbsp;주소 : 서울특별시 강남구 테헤란로 131 한국지식재산센터 15층 토스페이먼츠 주식회사</li>
                                                <li>o&nbsp;&nbsp;이메일 주소 : support@tosspayments.com</li>
                                                <li>o&nbsp;&nbsp;전화번호 : 1544-7772</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제9조 (오류의 정정 등)</p>
                                    <ol>
                                        <li>① 이용자는 전자지급결제대행 서비스를 이용함에 있어 오류가 있음을 안 때에는 회사에 대하여 그 정정을 요구할 수 있습니다.</li>
                                        <li>② 회사는 전항의 규정에 따른 오류의 정정요구를 받은 때에는 이를 즉시 조사하여 처리한 후 정정요구를 받은 날부터 2주 이내에 그 결과를 이용자에게 알려 드립니다.</li>
                                        <li>
                                            ③ 이용자는 다음의 주소 및 전화번호로 본 조항상의 정정 요구를 할 수 있습니다.
                                            <ol>
                                                <li>o&nbsp;&nbsp;주소 : 서울특별시 강남구 테헤란로 131 한국지식재산센터 15층 토스페이먼츠 주식회사</li>
                                                <li>o&nbsp;&nbsp;이메일 주소 : support@tosspayments.com</li>
                                                <li>o&nbsp;&nbsp;전화번호: 1544 - 7772</li>
                                            </ol>
                                        </li>
                                        <li>④ 회사는 스스로 전자금융거래에 오류가 있음을 안 때에는 이를 즉시 조사하여 처리한 후 오류가 있음을 안 날부터 2주 이내에 오류의 원인과 처리 결과를 이용자에게 알려 드립니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제10조 (전자지급결제대행 서비스 이용 기록의 생성 및 보존)</p>
                                    <ol>
                                        <li>① 회사는 이용자가 전자지급결제대행 서비스 이용거래의 내용을 추적, 검색하거나 그 내용에 오류가 발생한 경우에 이를 확인하거나 정정할 수 있는 기록을 생성하여 보존합니다.</li>
                                        <li>② 전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및 보존방법은 제8조 제2항에서 정한 바에 따릅니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제11조 (거래지시의 철회 제한)</p>
                                    <ol>
                                        <li>① 이용자가 전자지급거래를 한 경우, 지급의 효력은 ‘전자금융거래법’ 제13조 각호의 규정에 따릅니다.</li>
                                        <li>② 이용자는 ‘전자금융거래법’ 제13조 각호의 규정에 따라 지급의 효력이 발생하기전까지 거래지시를 철회할 수 있습니다. 단, 금융기관, 이동통신사 등의 규정에 의거 거래지시의 철회가 제한될 수 있습니다..</li>
                                        <li>
                                            ③ 전자지급수단별 거래지시의 철회 방법 및 제한 등은 다음 각호와 같습니다.
                                            <ol>
                                                <li>1. 신용카드결제, 계좌이체결제, 가상계좌결제 : 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령에서 정한 바에 따라 재화의 구입 또는 용역의 이용 거래에서의 청약의 철회 등을 한 경우에 한하여 철회가 가능합니다.</li>
                                                <li>2. 휴대폰결제, KT전화(ARS,폰빌)결제: 전 가호의 방법에 따른 청약철회 요청건 중 이동통신사의 규정에 의거 결제일 해당월 말일까지 발생한 거래건에 한하여 철회가 가능합니다.</li>
                                                <li>3. 상품권결제: 전 가호의 방법에 따른 청약철회 요청 건 중 시스템 장애 등으로 정상적인 서비스를 이용하지 못한 경우에 한하여 결제일로부터 10일 이내 청약 철회가 가능합니다.</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제12조 (추심이체의 출금 동의 및 철회)</p>
                                    <ol>
                                        <li>① 회사는 이용자의 요청이 있는 경우 이용자의 계좌가 개설되어 있는 금융회사 등이 추심이체를 실행할 수 있도록 금융회사 등을 대신하여 전자금융거래법령 등 관련 법령에 따른 방법으로 출금에 대한 동의를 진행합니다.</li>
                                        <li>② 회사는 전 항에 따른 이용자의 동의 사항을 추심 이체를 실행하는 해당 금융회사 등에 제출합니다.</li>
                                        <li>③ 이용자는 이용자의 계좌의 원장에 출금기록이 끝나기 전까지 회사 또는 해당 금융회사 등에 제1항의 규정에 따른 동의의 철회를 요청할 수 있습니다.</li>
                                        <li>④ 전 항에도 불구하고 회사 또는 금융회사 등은 대량으로 처리하는 거래 또는 예약에 따른 거래 등의 경우에는 미리 이용자와 정한 약정에 따라 동의의 철회시기를 달리 정할 수 있습니다.</li>
                                        <li>⑤ 이용자가 제3항에 따라 출금 동의 철회를 요청한 경우, 이용자는 출금 동의 철회 요청 이후 발생한 출금에 대해서 제14조 제1항의 담당자에게 이의를 제기할 수 있습니다. 다만, 본 조항은 동의 철회요청 이전에 발생한 출금에 대해서는 적용되지 않습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제13조 (전자금융거래정보의 제공금지)</p>
                                    <p class="titHtext">회사는 전자지급결제대행서비스 및 결제대금예치서비스를 제공함에 있어서 취득한 이용자의 인적사항, 이용자의 계좌, 접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료를 이용자의 동의를 얻지 아니하고 제3자에게 제공,누설하거나 업무상 목적 외에 사용하지 아니합니다. 단, ‘금융실명 거래 및 비밀 보장에 관한 법률’ 제4조 제1항 단서의 규정에 따른 경우 그 밖의 다른 법률에서 정하는 바에 따른 경우에는 그러하지 아니합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제14조 (분쟁처리 및 분쟁조정)</p>
                                    <ol>
                                        <li>
                                            ① 이용자는 다음의 분쟁처리 책임자 및 담당자에 대하여 전자지급결제대행 서비스 및 결제대금예치서비스 이용과 관련한 의견 및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할 수 있습니다.
                                            <ol>
                                                <li>o&nbsp;&nbsp;담당자 : 토스페이먼츠 RM(리스크)팀</li>
                                                <li>o&nbsp;&nbsp;연락처 : 전화번호 1544-7772, 팩스 02-6919-2354</li>
                                                <li>o&nbsp;&nbsp;이메일 : rm@tosspayments.com</li>
                                            </ol>
                                        </li>
                                        <li>② 이용자가 회사에 대하여 분쟁처리를 신청한 경우에는 회사는 15일 이내에 이에 대한 조사 또는 처리 결과를 이용자에게 안내합니다.</li>
                                        <li>③ 이용자는 '금융위원회의 설치 등에 관한 법률' 제51조의 규정에 따른 금융감독원의 금융분쟁조정위원회나 '소비자기본법' 제35조 제1항의 규정에 따른 소비자원에 회사의 전자지급결제대행서비스 및 결제대금예치서비스의 이용과 관련한 분쟁조정을 신청할 수 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제15조 (회사의 안정성 확보 의무)</p>
                                    <p class="titHtext">회사는 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제16조 (이용시간)</p>
                                    <ol>
                                        <li>① 회사는 이용자에게 연중무휴 1일 24시간 전자금융거래 서비스를 제공함을 원칙으로 합니다. 단, 금융기관 기타 결제수단 발행업자의 사정에 따라 변경될 수 있습니다.</li>
                                        <li>② 회사는 정보통신설비의 보수, 점검 기타 기술상의 필요나 금융기관 기타 결제수단 발행업자의 사정에 의하여 서비스 중단이 불가피한 경우, 서비스 중단 3일 전까지 게시가능한 전자적 수단을 통하여 서비스 중단 사실을 게시한 후 서비스를 일시 중단할 수 있습니다. 다만, 시스템 장애보국, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 사전 게시없이 서비스를 중단할 수 있습니다.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">제17조 (약관외 준칙 및 관할)</p>
                                    <ol>
                                        <li>① 이 약관에서 정하지 아니한 사항에 대하여는 전자금융거래법, 전자상거래 등에서의 소비자 보호에 관한 법률, 통신판매에 관한 법률, 여신전문금융업법 등 소비자보호 관련 법령에서 정한 바에 따릅니다.</li>
                                        <li>② 회사와 이용자간에 발생한 분쟁에 관한 관할은 민사소송법에서 정한 바에 따릅니다.</li>
                                    </ol>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : TOSS 전자금융거래 기본 약관 -->

                    <!-- S : TOSS 개인정보 제3자 제공 동의 -->
                    <li>
                        <strong class="titH1 txt-titH1" id="titNo05" ref="titNo05">TOSS 개인정보 제3자 제공 동의</strong>
                        <ul class="box_customer-terms">
                            <li>
                                <div class="pdBox">
                                    <p class="titHtext">토스페이먼츠(이하 회사라 함)는 전자금융거래 서비스의 제공을 위하여 개인정보가 제3자 제공되는 경우는 이용 서비스 및 결제수단별로 다음과 같습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">1. 개인정보를 제공받는 자, 제공하는 목적 및 항목</p>
                                    <p class="titHtext">•&nbsp;&nbsp;가. 전자결제지급대행 서비스 제공을 위한 결제정보 제공</p>
                                    <table class="tbl-type1 line-st" style="margin-bottom:12px;">
                                        <caption>개인정보를 제공받는 자, 제공하는 목적 및 항목 표 : 제공목적, 제공받는 자, 제공하는 항목</caption>
                                        <colgroup>
                                            <col width="25%">
                                            <col width="37.5%">
                                            <col width="37.5%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">제공목적</th>
                                                <th scope="col">제공받는 자</th>
                                                <th scope="col">제공하는 항목</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>신용카드</th>
                                                <td class="left">
                                                    [신용카드사] KB카드, 비씨카드, 롯데카드, 삼성카드, NH농협카드, 현대카드, 신한카드, KEB하나카드, 우리카드<br>
                                                    [은행] 경남은행, 광주은행, 국민은행, 기업은행, 농협은행, 대구은행, 부산은행, KDB산업은행, 새마을금고, 수협은행, 신한은행, 신협, 우리은행, 우체국, 전북은행, 제주은행, KEB하나은행, 씨티은행, SC제일은행, 산림조합중앙회, 케이뱅크, 카카오뱅크<br>
                                                    [VAN사] (㈜코밴, ㈜코세스 ,㈜다우데이타, 퍼스트데이터 코리아, ㈜에스피씨네트웍스, ㈜엑심베이
                                                </td>
                                                <td class="left">
                                                    [거래정보] 카드번호, 고객명, 생년월일, 전화번호<br>
                                                    [비인증결제의 경우 거래정보] 카드번호, 유효기간, 생년월일, 카드 비밀번호 앞 2자리)
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>해외카드 결제</th>
                                                <td class="left">VISA, MASTER, JCB, AMEX, Diners, 유니온페이 인터내셔널</td>
                                                <td class="left">카드번호, 유효기간, 전화번호, 회원ID, 카드 비밀번호</td>
                                            </tr>
                                            <tr>
                                                <th>간편결제</th>
                                                <td class="left">㈜비바리퍼블리카, ㈜에스에스지닷컴, 롯데멤버스㈜, 삼성전자㈜, LG전자㈜, 엔에이치엔페이코㈜</td>
                                                <td class="left">전화번호, 상품명</td>
                                            </tr>
                                            <tr>
                                                <th>신용카드 ARS결제</th>
                                                <td class="left">㈜엘지유플러스</td>
                                                <td class="left">카드번호, 전화번호, 유효기간</td>
                                            </tr>
                                            <tr>
                                                <th>계좌이체 결제</th>
                                                <td class="left">
                                                    [은행] NH농협, KB은행, 우리은행, 신한은행, 기업은행, 경남은행, 광주은행, 대구은행, 부산은행, KDB산업은행, 새마을금고, 수협은행, 신협, 우체국, 전북은행, 제주은행, KEB하나은행, 씨티은행, SC제일은행<br>
                                                    [증권사] 유안타, 미래에셋, 삼성, 한국투자, 한화
                                                </td>
                                                <td class="left">계좌번호, 고객명, 생년월일, 보안카드, OTP, (공인인증서 서명 검증 및 신원확인 시) 주민등록번호</td>
                                            </tr>
                                            <tr>
                                                <th>가상계좌 결제</th>
                                                <td class="left">[은행] 국민은행, 농협은행, 우리은행, 신한은행, KEB하나은행, 기업은행, 우체국, 부산은행, 경남은행, 대구은행, 수협은행</td>
                                                <td class="left">가상계좌번호</td>
                                            </tr>
                                            <tr>
                                                <th>휴대폰 결제</th>
                                                <td class="left">
                                                    [통신사] SK텔레콤㈜, ㈜케이티, ㈜엘지유플러스<br>
                                                    [중개사] ㈜다날, 갤럭시아커뮤니케이션즈㈜, 페이레터
                                                </td>
                                                <td class="left">이통사정보, 휴대폰번호, 생년월일, 성별, IP</td>
                                            </tr>
                                            <tr>
                                                <th>유선전화 결제</th>
                                                <td class="left">㈜케이티</td>
                                                <td class="left">전화번호, 생년월일, 성별</td>
                                            </tr>
                                            <tr>
                                                <th>상품권 결제</th>
                                                <td class="left">㈜한국문화진흥, 티알엔</td>
                                                <td class="left">‘구매자ID, 비밀번호’(또는 상품권번호)</td>
                                            </tr>
                                            <tr>
                                                <th>자체 간편결제 (신용카드)</th>
                                                <td class="left">[신용카드사] 신한카드, KB카드, 하나카드, BC카드, 삼성카드, NH농협카드, 현대카드, 롯데카드, 우리카드, 씨티카드</td>
                                                <td class="left">CI, 생년월일, 성별, 단말기 고유번호, 카드번호, 카드 CVC, 카드 유효기간, 카드 비밀번호</td>
                                            </tr>
                                            <tr>
                                                <th>자체 간편결제 (계좌이체)</th>
                                                <td class="left">금융결제원, [은행] NH농협은행, 농협중앙회, KB은행, KDB산업은행, 우리은행, 신한은행, 기업은행, 경남은행, 광주은행, 대구은행, 부산은행, 새마을금고, 수협, 수협중앙회, 신협, 우체국, 전북은행, 제주은행, KEB하나은행, 씨티은행, SC제일은행, 카카오뱅크, K뱅크, 산림조합중앙회 [증권사] 교보증권, 미래에셋대우, 삼성증권, 신한금융투자, 유진투자증권, 이베스트투자증권, 키움증권, 하이투자증권, 한국투자증권, 한화투자증권, 현대차증권, KB증권, NH투자증권, SK증권, 메리츠증권, 대신증권, DB금융투자</td>
                                                <td class="left">휴대전화번호, 이름, 계좌번호, 계좌 비밀번호, 주민번호</td>
                                            </tr>
                                            <tr>
                                                <th>글로벌서비스</th>
                                                <td class="left">알리페이</td>
                                                <td class="left">전화번호, 회원ID, 비밀번호</td>
                                            </tr>
                                            <tr>
                                                <th>현금영수증서비스</th>
                                                <td class="left">국세청, 제이티넷</td>
                                                <td class="left">[현금영수증 발급정보] 주민등록번호, 사업자번호, 휴대폰번호, 현금영수증 등록카드번호</td>
                                            </tr>
                                            <tr>
                                                <th>신용카드 유효성 검증 서비스</th>
                                                <td class="left">[신용카드사] KB카드, 비씨카드, 롯데카드, 삼성카드, NH농협카드, 현대카드, 신한카드, KEB하나카드, 우리카드</td>
                                                <td class="left">
                                                    카드번호, 고객명, 생년월일, 전화번호<br>
                                                    ※ BC카드는 IP주소 포함
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계좌 유효성확인 서비스</th>
                                                <td class="left">[은행] 경남은행, 광주은행, 국민은행, 기업은행, 농협은행, 대구은행, 부산은행, KDB산업은행, 새마을금고, 수협, 신한은행, 신협, 외환은행, 우리은행, 우체국, 전북은행, 제주은행, 하나은행, 씨티은행, SC제일은행</td>
                                                <td class="left">계좌번호, 고객명, 생년월일</td>
                                            </tr>
                                            <tr>
                                                <th>휴대폰 본인확인 서비스</th>
                                                <td class="left">㈜케이티, ㈜엘지유플러스, KMC㈜</td>
                                                <td class="left">성명, 생년월일, 성별, 휴대폰번호, 내외국인 식별정보, CI, DI</td>
                                            </tr>
                                            <tr>
                                                <th>오픈뱅킹 서비스(출금이체, 입금이체, 잔액조회) 제공</th>
                                                <td class="left">금융결제원</td>
                                                <td class="left">이름, 생년월일, 휴대전화번호, 금융기관명 및 계좌번호, 암호화된 동일인 식별정보(CI), 이메일</td>
                                            </tr>
                                            <tr>
                                                <th>관련 법령에 따른 의무 이행</th>
                                                <td class="left">금융정보분석원, 국세청</td>
                                                <td class="left">실명번호, 거래목적, 자금원천</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p class="mgtS txt-italic" style="margin-left:0;font-style:normal;">회사는 개인정보를 위의 목적으로 제3자 제공하며, 동의받은 목적 이외의 제3자에게 제공하지 처리하지 않습니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">2. 개인정보의 보유 및 이용기간</p>
                                    <p class="titHtext">개인정보는 원칙적으로 개인정보의 수집·이용 목적이 달성되면 지체없이 파기합니다. 단, 다른 법령에 특별한 규정이 있는 경우 관련 법령에서 정하는 기간동안 보유합니다.</p>
                                </div>
                            </li>
                            <li>
                                <div class="pdBox">
                                    <p class="titH2">3. 이용자는 회사의 개인정보 제3자 제공에 대한 동의를 거부할 권리가 있습니다.</p>
                                    <p class="titHtext">다만, 개인정보의 제3자 제공 동의를 거부할 경우 전자결제지급대행 서비스의 이용이 제한될 수 있음을 알려드립니다.</p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <!-- E : TOSS 개인정보 제3자 제공 동의 -->
                </ul>
            </div>
        </div>
    </div>

    <div id="ScrollTopArea" class="scrollTopWrapper" style="opacity: 1;">
        <button type="button" class="toTop" @click="scrollToTop">TOP(위로이동)</button>
    </div>
</div>
    <div id="uiLayerMask" style="display:none"></div>
  </body>
</template>

<script>

export default {
  name: 'termsBasketsop',
  data () {
    return {}
  },
  methods: {
    scrollToTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    scrollToElement (target) {
      let element = this.$refs[target]
      let top = element.offsetTop
      window.scroll({
        left: 0,
        top: top,
        behavior: 'smooth'
      })
    },
    eventHandlerWrapper (callback) {
      let tick = false

      return () => {
        if (tick) {
          return
        }

        tick = true

        return requestAnimationFrame(() => {
          tick = false
          return callback()
        })
      }
    },
    toggleButton () {
      this.toggle = window.scrollY !== 0
    }
  },
  mounted: function () {
    this.toggle = window.scrollY !== 0

    window.addEventListener('scroll', this.eventHandlerWrapper(this.toggleButton), { passive: true })
    let termsIndex = this.$route.query['terms-index']
    if (termsIndex) {
      setTimeout(() => {
        let element = this.$refs['titNo0' + termsIndex]
        if (element) {
          window.scroll({
            top: element.offsetTop,
            left: 0,
            behavior: 'smooth'
          })
        }
      }, 400)
    }
  },
  created: function () {
    
  }
}
</script>

<style>
@import './css/akl-compliance-renewal.css';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/amwayterms/termsBasksop.vue